import axios from "axios";
import config from "../config";

const instance = axios.create({
  baseURL: config.OKF_API_ROOT
});

export default instance;
